import {ToggleButton, styled} from '@mui/material';
import {alpha} from '@mui/material/styles';
import {ORANGE_COLOR, ORANGE_COLOR_HOVER, WHITE_COLOR} from '../../styles';

/**
 * Orange-outlined toggle button used by the team filter controls. Shared by
 * Team Shift Utilization and the Team Players roster so the two stay in step.
 */
const HeliosToggleButton = styled(ToggleButton)(() => ({
  paddingTop: 5,
  paddingBottom: 5,
  border: `1px solid ${alpha(ORANGE_COLOR_HOVER, 0.5)}`,
  color: ORANGE_COLOR,
  '&:hover': {
    backgroundColor: alpha(ORANGE_COLOR_HOVER, 0.08),
    border: `1px solid ${ORANGE_COLOR_HOVER}`,
  },
  '&.Mui-selected': {
    backgroundColor: ORANGE_COLOR,
    color: WHITE_COLOR,
  },
  '&.Mui-selected:hover': {
    backgroundColor: ORANGE_COLOR_HOVER,
    border: `1px solid ${ORANGE_COLOR_HOVER}`,
  },
}));

export default HeliosToggleButton;
